module.exports = __webpack_public_path__ + "img/seoulgov.a6bcdd63.svg";